module.exports = __webpack_public_path__ + "img/inactive-23.d503a2f3.svg";